import React from 'react';
//import PropTypes from 'prop-types';
import './home.css'
import video from './video.mp4';
import videoOgv from './video.ogv';
import videoWebm from './video.webm';

export const Home = () => {
  return (
    <div>
      <div id="videoContainer">
      <video id="video" autoPlay playsInline loop muted>
        <source src={video} type="video/mp4"/>
        <source src={videoWebm} type="video/webm"/>
        <source src={videoOgv} type="video/ogg"/>
      </video>
      </div>
      <section className="home-content">
        <div>
            <h1 className="text-primary">Windsurfer, Photographer and Chef</h1>
          <p className="text-light">Those who improve with age embrace the power of personal growth and personal achievement and begin to replace youth with wisdom, innocence with understanding, and lack of purpose with self-actualization.</p>
          {/*<p className="text-light">Michael Witt is a professional Web developer, who is excited about new technology and continuous education. His experience working in different industries and with a broad range of technical challenges made him a strong problem solver.</p>*/}
          {/*<p>After over ten years working in Web development, currently seeking a new challenge  which will utilize his meticulous attention to detail, and friendly, professional manner.</p>*/}
        </div>

      </section>
    </div>
  )
};




// WEBPACK FOOTER //
// ./src/components/home/Home.js